import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=d85cbe88&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=d85cbe88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85cbe88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d85cbe88')) {
      api.createRecord('d85cbe88', component.options)
    } else {
      api.reload('d85cbe88', component.options)
    }
    module.hot.accept("./ConfirmModal.vue?vue&type=template&id=d85cbe88&scoped=true", function () {
      api.rerender('d85cbe88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/ConfirmModal.vue"
export default component.exports